import React from 'react'
import styled from 'styled-components'
import { useTranslation, Trans } from 'react-i18next'

import benefitsWave from 'src/assets/images/landing/benefits-wave.svg'

import Ellipse16 from 'src/assets/images/vectors/ellipse-16.svg'
import Vector9Lp from 'src/assets/images/vectors/vector-9-lp.svg'
import PandaPanelPreview from 'src/assets/images/vectors/panda-panel-preview.svg'
import PanelInputPreview from 'src/assets/images/vectors/panel-input-preview.svg'
import SlackLogo from 'src/assets/images/vectors/slack-logo.svg'

import {
  round1,
  round2,
  round3,
} from 'src/components/AnimationKeyframes'

export const BenefitsSection = (props) => {
  const { t } = useTranslation()

  return (
    <BenefitsSectionContainer>
      <div className='benefits__content'>
        <div className='benefits__content-container'>
          <div className='benefits__top-section'>
            <h1 className='benefits__top-section__title'>
              <Trans i18nKey='landingPage.benefitsSection.title'>
                <span>0</span>
                <div></div>
                <span>1</span>
              </Trans>
            </h1>
            <p className='benefits__top-section__subtitle'>{t('landingPage.benefitsSection.subtitle')}</p>
          </div>
          <div className='benefits__items'>
            <div className='benefits__items__tiles'>
              <div className='benefit-tile'>
                <Trans i18nKey='landingPage.benefitsSection.benefit1'>
                  <span>0</span>
                  <div></div>
                  <span>1</span>
                </Trans>
              </div>
              <div className='benefit-tile'>
                <Trans i18nKey='landingPage.benefitsSection.benefit2'>
                  <span>0</span>
                  <div></div>
                  <span>1</span>
                </Trans>
              </div>
              <div className='benefit-tile'>
                <Trans i18nKey='landingPage.benefitsSection.benefit3'>
                  <span>0</span>
                  <div></div>
                  <span>1</span>
                </Trans>
              </div>
              <div className='benefit-tile'>
                <Trans i18nKey='landingPage.benefitsSection.benefit4'>
                  <span>0</span>
                  <div></div>
                  <span>1</span>
                </Trans>
              </div>
            </div>
          </div>
          <div className='benefit__items__images'>
            <img className='ellipse-16' src={Ellipse16} alt='ellipse-16'/>
            <img className='vector-9-lp' src={Vector9Lp} alt='vector-9-lp'/>
            <img className='panda-panel-preview' src={PandaPanelPreview} alt='panda-panel-preview'/>
            <img className='panel-input-preview' src={PanelInputPreview} alt='panel-input-preview' />
            <img className='slack-logo' src={SlackLogo} alt='slack-logo'/>
          </div>
        </div>
      </div>
      <img className='benefits__bottom-background' src={benefitsWave} alt='benefits-section-bottom-wave'/>
    </BenefitsSectionContainer>
  )
}

export default BenefitsSection

const BenefitsSectionContainer = styled.div`
  overflow: hidden;
  .benefits__content {
    color: ${props => props.theme.palette.common.black};
    text-align: center;
    background-color: ${props => props.theme.palette.primary.main};
    padding-top: 64px;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 32px;

    ${props => props.theme.breakpointsMedia.desktop} {
      padding-bottom: 264px;
    }

    .benefits__content-container {
      display: flex;
      justify-content: center;
      flex-direction: column;

      ${props => props.theme.breakpointsMedia.desktop} {
        width: 1001px;
        margin: 0 auto;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
      }
    }
  }
  
  .benefits__top-section {
    line-height: 1.5;
    text-align: left;
    color: ${props => props.theme.palette.common.white};

    ${props => props.theme.breakpointsMedia.desktop} {
      width: 500px;
      order: 1;
    }

    .benefits__top-section__title {
      font-weight: 300;
      font-size: 30px;
  
      div:nth-child(2) {
        font-weight: 800;
      }

      ${props => props.theme.breakpointsMedia.desktop} {
        font-size: 48px;
  
        div:nth-child(2) {
          font-size: 46px;
        }
      }
    }

    .benefits__top-section__subtitle {
      margin-top: 18px;
      font-weight: 500;
      font-size: 18px;
    }
  }
  
  .benefits__bottom-background {
    width: 100%;
    margin-top: -1px;
  }
  
  .benefits__items {
    width: 100%;

    ${props => props.theme.breakpointsMedia.desktop} {
      width: 500px;
      order: 3;
    }

    .benefits__items__tiles {
      display: flex;
      flex-direction: column;
      margin-top: 16px;

      ${props => props.theme.breakpointsMedia.desktop} {
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 16px;
        width: 500px;
        height: 250px;
      }

      .benefit-tile {
        box-sizing: border-box;
        width: 100%;
        height: 117px;
        background-color: ${props => props.theme.palette.primary.dark};
        color: ${props => props.theme.palette.common.white};
        font-size: 18px;
        margin-top: 8px;
        border-radius: 8px;
        padding: 16px 8px;
        margin: 8px auto;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        ${props => props.theme.breakpointsMedia.tablet} {
          flex-basis: 100%;
        }

        ${props => props.theme.breakpointsMedia.desktop} {
          width: 242px;
          height: 117px;
          margin: 0;
        }

        span:nth-child(1) {
          font-weight: 800;
        }

        span:nth-child(2) {
          font-weight: 800;
        }
      }
    }
  }

  .benefit__items__images {
    width: 100%;
    position: relative;
    height: 362px;

    ${props => props.theme.breakpointsMedia.desktop} {
      width: 460px;
      order: 2;
      height: unset;
      margin: 0 auto;
    }

    img {
      position: absolute;

      &.ellipse-16 {
        width: 30px;
        left: calc(50vw - 100px);
        top: 310px;
        animation: ${round1} 8s linear infinite;
      }
    
      &.vector-9-lp {
        width: 280px;
        left: calc(50vw - 140px);
        top: 50px;
        animation: ${round2} 4s linear infinite;
      }
    
      &.panda-panel-preview {
        width: 240px;
        left: calc(50vw - 120px);
        top: 90px;
        border-radius: 8px;
      }

      &.panel-input-preview {
        left: calc(50vw - 83px);
        width: 240px;
        top: 56px;
      }
    
      &.slack-logo {
        width: 100px;
        left: calc(50vw + 10px);
        top: 300px;
        animation: ${round3} 6s linear infinite;
      }
    

      ${props => props.theme.breakpointsMedia.desktop} {
        &.ellipse-16 {
          width: 47px;
          top: 500px;
          left: 150px;
        }
      
        &.vector-9-lp {
          width: 550px;
          top: 0;
          left: 60px;
        }
      
        &.panda-panel-preview {
          width: 440px;
          top: 110px;
          left: 35px;
        }

        &.panel-input-preview {
          left: 100px;
          width: 440px;
          top: 45px;
        }
      
        &.slack-logo {
          width: 250px;
          top: 450px;
          left: 250px;
        }
      }
    }
  }
`
